// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_3ZlO2","headItem":"index_headItem_2MUjd","headIcon":"index_headIcon_27EQE","table":"index_table_pFzt8","avatar":"index_avatar_T9wL5"};